import { get_session9cytjmfbg8nd as get_session } from '../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { pushChanges1lnw8bjwewvzf as pushChanges } from '../../utils/Draft.ext.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  toSet2orjxp16sotqu as toSet,
  firstOrNull1982767dljvdy as firstOrNull,
  sortedWith2csnbbb21k0lg as sortedWith,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  get_dialogStackleaqvayyucjw as get_dialogStack,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
} from '../components/nav/crowpay.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ReactiveMutableList2gg4x024enrbf as ReactiveMutableList } from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveMutableList.mjs';
import { Draft43syxm8fng0j as Draft } from '../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { ScopeView2pjeasrtqdymw as ScopeView } from '../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_scopeTitle3b12utn8vsli8 as get_scopeTitle,
  get_description20dyln4owxipr as get_description,
} from '../../../../../crowpay-shared/com/crowpay/ScopeViewFields.mjs';
import { lensPath2kkrykycsgvs9 as lensPath } from '../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import {
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  SubtextSemantic_getInstance3oi0npjp97gok as SubtextSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  plus2opbwe063z9pg as plus,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { times2ukvaf6yk96p2 as times } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  title1nssp3ryhwuqj as title,
  bodyBold2czwdzwknab0k as bodyBold,
} from '../theming/Titles.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../theming/colorManagement.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { nullToBlank26aqgq3jx9stc as nullToBlank } from '../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { errorTextv58wi1t0me7u as errorText } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { checkboxSelectLineItems1dke5tjc0acqf as checkboxSelectLineItems } from './NewScopeViewDialog.mjs';
import { label287uhiq3m9m4z as label2 } from '../components/label2.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  maybeSpecCenteredText3k2zk0rmdqomq as maybeSpecCenteredText,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  maybeSpecCenteredText1iusdmvklvsob as maybeSpecCenteredText_0,
} from '../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = pushChanges($this.pib_1.nib_1, session.ufv_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var scope = tmp_0;
  // Inline function 'kotlin.collections.map' call
  var this_1 = $this.pib_1.mib_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$1 = item.kf9_1;
    destination.v(tmp$ret$1);
  }
  var selected = destination;
  var tmp_1 = toSet(selected);
  // Inline function 'kotlin.collections.map' call
  var this_2 = $this.pib_1.lib_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList().u(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s_0 = this_2.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var item_0 = _iterator__ex2g4s_0.o1();
    var tmp$ret$4 = item_0.kf9_1;
    destination_0.v(tmp$ret$4);
  }
  if (!equals(tmp_1, toSet(destination_0))) {
    var tmp_2 = session.tfw().vfg_1.yfq(scope.k7z_1, selected, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  var tmp0_safe_receiver = $this.pib_1.gib_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp_3 = tmp0_safe_receiver(scope, selected, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  get_dialogStack().ngd();
  return Unit_instance;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.qib_1 = function_0;
      }
      wi(a, b) {
        return this.qib_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.qib_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$expandIfNarrow_7oxayk(_this__u8e3s4) {
  return get_viewIsNarrow(_this__u8e3s4) ? get_expanding(_this__u8e3s4) : Companion_getInstance();
}
function EditScopeViewDialog$options$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.hf9_1.b6l_1;
  var tmp$ret$1 = b.hf9_1.b6l_1;
  return compareValues(tmp, tmp$ret$1);
}
var EditScopeViewDialog$render$slambdaClass;
function EditScopeViewDialog$render$slambda() {
  if (EditScopeViewDialog$render$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditScopeViewDialog$render$slambdaClass = $;
  }
  return EditScopeViewDialog$render$slambdaClass;
}
function EditScopeViewDialog$render$slambda_0() {
  var i = new (EditScopeViewDialog$render$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var EditScopeViewDialog$render$slambdaClass_0;
function EditScopeViewDialog$render$slambda_1() {
  if (EditScopeViewDialog$render$slambdaClass_0 === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditScopeViewDialog$render$slambdaClass_0 = $;
  }
  return EditScopeViewDialog$render$slambdaClass_0;
}
function EditScopeViewDialog$render$slambda_2() {
  var i = new (EditScopeViewDialog$render$slambda_1())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var EditScopeViewDialog$render$slambdaClass_1;
function EditScopeViewDialog$render$slambda_3() {
  if (EditScopeViewDialog$render$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.pib_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditScopeViewDialog$render$slambdaClass_1 = $;
  }
  return EditScopeViewDialog$render$slambdaClass_1;
}
function EditScopeViewDialog$render$slambda_4(this$0) {
  var i = new (EditScopeViewDialog$render$slambda_3())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var EditScopeViewDialogClass;
function EditScopeViewDialog() {
  if (EditScopeViewDialogClass === VOID) {
    class $ {
      constructor(options, scope, parent, allowEmptySelection, withUpdates) {
        allowEmptySelection = allowEmptySelection === VOID ? false : allowEmptySelection;
        withUpdates = withUpdates === VOID ? null : withUpdates;
        this.dib_1 = scope;
        this.eib_1 = parent;
        this.fib_1 = allowEmptySelection;
        this.gib_1 = withUpdates;
        var tmp = this;
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().w();
        var _iterator__ex2g4s = options.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (equals(element.nfy(), this.dib_1.k7z_1)) {
            destination.v(element);
          }
        }
        tmp.hib_1 = destination;
        var tmp_0 = this;
        var tmp_1;
        if (this.dib_1.q7z_1 == null) {
          tmp_1 = emptyList();
        } else {
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination_0 = ArrayList().w();
          var _iterator__ex2g4s_0 = options.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            if (!(element_0.nfy() == null) && equals(element_0.nfy(), this.dib_1.q7z_1)) {
              destination_0.v(element_0);
            }
          }
          tmp_1 = destination_0;
        }
        tmp_0.iib_1 = tmp_1;
        var tmp_2 = this;
        var tmp_3;
        var tmp_4;
        if (this.dib_1.p7z_1) {
          tmp_4 = true;
        } else {
          var tmp3_safe_receiver = this.eib_1;
          tmp_4 = (tmp3_safe_receiver == null ? null : tmp3_safe_receiver.p7z_1) === true;
        }
        if (tmp_4) {
          var tmp0_safe_receiver = firstOrNull(this.hib_1);
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kfy();
          var tmp_5;
          if (tmp1_elvis_lhs == null) {
            var tmp2_safe_receiver = firstOrNull(this.iib_1);
            tmp_5 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.kfy();
          } else {
            tmp_5 = tmp1_elvis_lhs;
          }
          tmp_3 = tmp_5;
        } else {
          tmp_3 = null;
        }
        tmp_2.jib_1 = tmp_3;
        var tmp_6 = this;
        // Inline function 'kotlin.run' call
        var tmp_7;
        if (this.dib_1.q7z_1 == null) {
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination_1 = ArrayList().w();
          var _iterator__ex2g4s_1 = options.m1();
          while (_iterator__ex2g4s_1.n1()) {
            var element_1 = _iterator__ex2g4s_1.o1();
            if (equals(element_1.nfy(), this.dib_1.k7z_1) || (element_1.nfy() == null && (this.jib_1 == null || element_1.kfy().equals(this.jib_1)))) {
              destination_1.v(element_1);
            }
          }
          tmp_7 = destination_1;
        } else {
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination_2 = ArrayList().w();
          var _iterator__ex2g4s_2 = options.m1();
          while (_iterator__ex2g4s_2.n1()) {
            var element_2 = _iterator__ex2g4s_2.o1();
            if (equals(element_2.nfy(), this.dib_1.k7z_1) || equals(element_2.nfy(), this.dib_1.q7z_1)) {
              destination_2.v(element_2);
            }
          }
          tmp_7 = destination_2;
        }
        // Inline function 'kotlin.collections.sortedBy' call
        var this_0 = tmp_7;
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp_8 = EditScopeViewDialog$options$lambda;
        var tmp$ret$14 = new (sam$kotlin_Comparator$0())(tmp_8);
        tmp_6.kib_1 = sortedWith(this_0, tmp$ret$14);
        var tmp_9 = this;
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination_3 = ArrayList().w();
        var _iterator__ex2g4s_3 = options.m1();
        while (_iterator__ex2g4s_3.n1()) {
          var element_3 = _iterator__ex2g4s_3.o1();
          if (equals(element_3.nfy(), this.dib_1.k7z_1)) {
            destination_3.v(element_3);
          }
        }
        tmp_9.lib_1 = destination_3;
        this.mib_1 = ReactiveMutableList().uam(this.lib_1);
        this.nib_1 = Draft(this.dib_1);
        var tmp_10 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_1 = this.nib_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_11 = serializerOrContextual(createKType(getKClass(ScopeView()), arrayOf([]), false));
        var tmp$ret$19 = isInterface(tmp_11, KSerializer()) ? tmp_11 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$19);
        var tmp$ret$21 = get_scopeTitle(it);
        tmp_10.oib_1 = lensPath(this_1, tmp$ret$21);
      }
      ud6(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.tbo(EditScopeViewDialog$render$slambda_0());
        view.eba(get_AppDimensions().wg1_1);
        view.zb8(get_AppDimensions().wg1_1);
        var tmp = view.ibb(view.ibb(get_centered(view), view.hbb(DialogSemantic_getInstance())), sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, plus(get_rem(40), times(get_AppDimensions().wg1_1, 2)), plus(get_rem(40), times(get_AppDimensions().wg1_1, 2))));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.eba(get_AppDimensions().wg1_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.xbm(true);
        view_1.zb8(get_AppDimensions().xg1_1);
        title(view_1, !(this.dib_1.q7z_1 == null) ? 'Edit Group' : this.dib_1.p7z_1 ? 'Edit Scope Set' : 'Edit Scope View');
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label = !(this.dib_1.q7z_1 == null) ? 'Group Title' : 'Scope Title';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        view_2.xbm(true);
        view_2.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.ebb(p_3, view_3);
        view_3.xbm(false);
        view_3.zb8(get_AppDimensions().pg2_1);
        view_3.jbb(get_centered(view_3), bodyBold(view_3, label));
        view_3.jbb(colored(view_3, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_3, '*'));
        view_2.fbb(p_3, view_3);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_0 = view_2.hbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (TextInput())(view_2.pc());
        var tmp0_elvis_lhs_4 = view_2.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
        view_2.ebb(p_4, view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        var value = !(this.dib_1.q7z_1 == null) ? 'Group Title' : 'Scope Title';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_4.tb5_1.zb3_1.ib7_1.placeholder = value;
        view_4.xah(view_4.gcn_1, this.oib_1);
        view_2.fbb(p_4, view_4);
        view_2.jbb(tmp_0, view_4);
        view_1.fbb(p_2, view_2);
        // Inline function 'com.crowpay.views.components.field2' call
        var label_0 = 'Description (Optional)';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_5 = view_1.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_1 : tmp0_elvis_lhs_5;
        view_1.ebb(p_5, view_5);
        view_5.xbm(true);
        view_5.zb8(get_AppDimensions().ng2_1);
        bodyBold(view_5, label_0);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_1 = view_5.hbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_0 = this.nib_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_2 = serializerOrContextual(createKType(getKClass(ScopeView()), arrayOf([]), false));
        var tmp$ret$17 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$17);
        var tmp$ret$19 = get_description(it);
        var desc = lensPath(this_0, tmp$ret$19);
        var tmp_3 = sizeConstraints(view_5, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(7));
        // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (TextArea())(view_5.pc());
        var tmp0_elvis_lhs_6 = view_5.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
        view_5.ebb(p_6, view_6);
        view_6.tcl('Description');
        view_6.xah(view_6.qcl_1, nullToBlank(desc));
        view_5.fbb(p_6, view_6);
        var tmp$ret$24 = view_5.jbb(tmp_3, view_6);
        view_5.jbb(tmp_1, tmp$ret$24);
        view_5.jbb(view_5.hbb(SubtextSemantic_getInstance()), errorText(view_5));
        view_1.fbb(p_5, view_5);
        var tmp_4 = get_expanding(view_1);
        view_1.jbb(tmp_4, label2(view_1, 'Add and Remove Work Items', VOID, ($this$label2) => $this$label2.jbb($this$label2.ibb(get_expanding($this$label2), get_scrolling($this$label2)), checkboxSelectLineItems($this$label2, this.mib_1, this.kib_1, this.dib_1.p7z_1))));
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (Space())(view_1.pc(), 0.5);
        var tmp0_elvis_lhs_7 = view_1.cbb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_1 : tmp0_elvis_lhs_7;
        view_1.ebb(p_7, view_7);
        view_1.fbb(p_7, view_7);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_8 = view_1.cbb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_1 : tmp0_elvis_lhs_8;
        view_1.ebb(p_8, view_8);
        view_8.xbm(false);
        var tmp_5 = view_8.ibb(view_8.ibb(get_centered(view_8), render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$expandIfNarrow_7oxayk(view_8)), get_secondaryButton(view_8));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (Button())(view_8.pc());
        var tmp0_elvis_lhs_9 = view_8.cbb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
        view_8.ebb(p_9, view_9);
        maybeSpecCenteredText(view_9, 'Discard');
        onClick(view_9, 'Discard Scope View Changes', VOID, EditScopeViewDialog$render$slambda_2());
        view_8.fbb(p_9, view_9);
        view_8.jbb(tmp_5, view_9);
        var tmp_6 = view_8.ibb(render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$expandIfNarrow_7oxayk(view_8), get_primaryButton(view_8));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (Button())(view_8.pc());
        var tmp0_elvis_lhs_10 = view_8.cbb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view_8 : tmp0_elvis_lhs_10;
        view_8.ebb(p_10, view_10);
        var tmp_7 = KMutableProperty0();
        var tmp_8 = Button$_get_enabled_$ref_61t7nx(view_10);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('enabled', 0, tmp_7, tmp_8, Button$_set_enabled_$ref_o8kynz(view_10));
        reactiveScope(view_10, ($this$reactiveScope) => {
          var tmp;
          var tmp_0;
          var tmp_1;
          if (this.fib_1) {
            tmp_1 = true;
          } else {
            // Inline function 'kotlin.collections.isNotEmpty' call
            tmp_1 = !$this$reactiveScope.baj(this.mib_1).i1();
          }
          if (tmp_1) {
            // Inline function 'kotlin.text.isNotBlank' call
            var this_0 = $this$reactiveScope.baj(this.oib_1);
            tmp_0 = !isBlank(this_0);
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            var tmp_2;
            if ($this$reactiveScope.baj(this.nib_1.aak())) {
              tmp_2 = true;
            } else {
              // Inline function 'kotlin.collections.map' call
              var this_2 = $this$reactiveScope.baj(this.mib_1);
              // Inline function 'kotlin.collections.mapTo' call
              var destination = ArrayList().u(collectionSizeOrDefault(this_2, 10));
              var _iterator__ex2g4s = this_2.m1();
              while (_iterator__ex2g4s.n1()) {
                var item = _iterator__ex2g4s.o1();
                var tmp$ret$38 = item.kf9_1;
                destination.v(tmp$ret$38);
              }
              var tmp_3 = toSet(destination);
              // Inline function 'kotlin.collections.map' call
              var this_3 = this.lib_1;
              // Inline function 'kotlin.collections.mapTo' call
              var destination_0 = ArrayList().u(collectionSizeOrDefault(this_3, 10));
              var _iterator__ex2g4s_0 = this_3.m1();
              while (_iterator__ex2g4s_0.n1()) {
                var item_0 = _iterator__ex2g4s_0.o1();
                var tmp$ret$41 = item_0.kf9_1;
                destination_0.v(tmp$ret$41);
              }
              tmp_2 = !equals(tmp_3, toSet(destination_0));
            }
            tmp = tmp_2;
          } else {
            tmp = false;
          }
          var tmp$ret$44 = tmp;
          this_1.set(tmp$ret$44);
          return Unit_instance;
        });
        maybeSpecCenteredText_0(view_10, ($this$maybeSpecCenteredText) => {
          var scope = $this$maybeSpecCenteredText.baj(this.nib_1);
          // Inline function 'kotlin.text.ifBlank' call
          var this_0 = $this$maybeSpecCenteredText.baj(this.oib_1);
          var tmp;
          if (isBlank(this_0)) {
            tmp = !(scope.q7z_1 == null) ? 'Group' : scope.p7z_1 ? 'Scope Set' : 'Scope View';
          } else {
            tmp = this_0;
          }
          return 'Save ' + tmp;
        });
        var tmp_9 = this.dib_1.p7z_1 ? 'Save Scope Set' : 'Save Scope View';
        onClick(view_10, tmp_9, VOID, EditScopeViewDialog$render$slambda_4(this));
        view_8.fbb(p_10, view_10);
        view_8.jbb(tmp_6, view_10);
        view_1.fbb(p_8, view_8);
        view_0.fbb(p_1, view_1);
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'EditScopeViewDialog', VOID, VOID, [Page()]);
    EditScopeViewDialogClass = $;
  }
  return EditScopeViewDialogClass;
}
//region block: exports
export {
  EditScopeViewDialog as EditScopeViewDialog24e1qiqowum8p,
};
//endregion

//# sourceMappingURL=EditScopeViewDialog.mjs.map
